import React from 'react'
import { Navigate, Outlet } from 'react-router-dom'
import { useAuth } from '../context/AuthContext'

const AdminRoute = () => {
  const { isAuthenticated, loading, user } = useAuth()

  if (loading) return null

  if (!isAuthenticated) return <Navigate to="/login" replace />

  return user?.role === 'ADMIN' ? <Outlet /> : <Navigate to="/" replace />
}

export default AdminRoute